import { z } from 'zod';
/** POST /api/v1/auth/totp/enroll response.
 *  Returned exactly once during enrollment — caller scans the QR code into
 *  their authenticator app and stores the secret. The secret is NOT returned
 *  on subsequent requests. */
export const TotpEnrollResponseSchema = z.object({
    secret: z.string(),
    otpauthUrl: z.string().url(),
    qrCodeDataUrl: z.string().startsWith('data:image/'),
});
/** POST /api/v1/auth/totp/verify body. TOTP codes are 6 digits per RFC 6238. */
export const TotpVerifyRequestSchema = z.object({
    code: z.string().regex(/^\d{6}$/, 'TOTP code must be 6 digits'),
});
/** Response after successful TOTP verification. */
export const TotpVerifyResponseSchema = z.object({
    status: z.literal('verified'),
    enrolledAt: z.string().datetime(),
});
/** Phase 14a-8 — POST /api/v1/auth/totp-step-up body.
 *  Same 6-digit shape as `/totp/verify`. Operator submits this when the
 *  admin UI catches a `totp_step_up_required` error and opens the
 *  step-up modal per 14a-6. On success the backend refreshes the
 *  session's `totpSatisfiedAt` so TotpFreshGuard accepts the next
 *  destructive call. */
export const TotpStepUpRequestSchema = z.object({
    token: z.string().regex(/^\d{6}$/, 'TOTP code must be 6 digits'),
});
/** Phase 14a-8 — success response from /api/v1/auth/totp-step-up. */
export const TotpStepUpResponseSchema = z.object({
    status: z.literal('ok'),
});
//# sourceMappingURL=totp.schema.js.map